import Vue from 'vue'
import date from './date/index.vue'
Vue.component('form-date', date);
import dates from './dates/index.vue'
Vue.component('form-dates', dates);
import group from './group/index.vue'
Vue.component('form-group', group);
import input from './input/index.vue'
Vue.component('form-input', input);
import phone from './phone/index.vue'
Vue.component('form-phone', phone);
import radio from './radio/index.vue'
Vue.component('form-radio', radio);
import select from './select/index.vue'
Vue.component('form-select', select);
import sum from './sum/index.vue'
Vue.component('form-sum', sum);
import textarea from './textarea/index.vue'
Vue.component('form-textarea', textarea);
import './index.scss'
